export const FETCH_FORMATION_SKILLS_REQUEST = "FETCH_FORMATION_SKILLS_REQUEST";
export const FETCH_FORMATION_SKILLS_SUCCESS = "FETCH_FORMATION_SKILLS_SUCCESS";
export const FETCH_FORMATION_SKILLS_FAIL = "FETCH_FORMATION_SKILLS_FAIL";

export const FETCH_ALL_FORMATION_SKILLS_REQUEST = "FETCH_ALL_FORMATION_SKILLS_REQUEST";
export const FETCH_ALL_FORMATION_SKILLS_SUCCESS = "FETCH_ALL_FORMATION_SKILLS_SUCCESS";
export const FETCH_ALL_FORMATION_SKILLS_FAIL = "FETCH_ALL_FORMATION_SKILLS_FAIL";

export const UPDATE_FORMATION_SKILLS_BULK_REQUEST = "UPDATE_FORMATION_SKILLS_BULK_REQUEST";
export const UPDATE_FORMATION_SKILLS_BULK_SUCCESS = "UPDATE_FORMATION_SKILLS_BULK_SUCCESS";
export const UPDATE_FORMATION_SKILLS_BULK_FAIL = "UPDATE_FORMATION_SKILLS_BULK_FAIL";

export const SET_FORMATION_SKILL_LOADING = "SET_FORMATION_SKILL_LOADING";
export const CLEAR_FORMATION_SKILL_ERROR = "CLEAR_FORMATION_SKILL_ERROR";

export const fetchFormationSkillsRequest = (formationId) => ({
    type: FETCH_FORMATION_SKILLS_REQUEST,
    payload: { formationId }
});

export const fetchFormationSkillsSuccess = (data) => ({
    type: FETCH_FORMATION_SKILLS_SUCCESS,
    payload: data
});

export const fetchFormationSkillsFail = (error) => ({
    type: FETCH_FORMATION_SKILLS_FAIL,
    error
});

export const fetchAllFormationSkillsRequest = () => ({
    type: FETCH_ALL_FORMATION_SKILLS_REQUEST
});

export const fetchAllFormationSkillsSuccess = (data) => ({
    type: FETCH_ALL_FORMATION_SKILLS_SUCCESS,
    payload: data
});

export const fetchAllFormationSkillsFail = (error) => ({
    type: FETCH_ALL_FORMATION_SKILLS_FAIL,
    error
});

export const updateFormationSkillsBulkRequest = (formationId, skills) => ({
    type: UPDATE_FORMATION_SKILLS_BULK_REQUEST,
    payload: { formationId, skills }
});

export const updateFormationSkillsBulkSuccess = () => ({
    type: UPDATE_FORMATION_SKILLS_BULK_SUCCESS
});

export const updateFormationSkillsBulkFail = (error) => ({
    type: UPDATE_FORMATION_SKILLS_BULK_FAIL,
    error
});

export const setFormationSkillLoading = (loading) => ({
    type: SET_FORMATION_SKILL_LOADING,
    payload: loading
});

export const clearFormationSkillError = () => ({
    type: CLEAR_FORMATION_SKILL_ERROR
});
